<template>
  <div>
  <b-form>
    <div class="d-flex justify-content-between">
      <h3 class="mb-0 mr-1">Editando administrador</h3>
      <button @click="save" type="button" class="btn btn-primary">Salvar</button>
    </div>

    <b-form-group label-class="font-weight-bold" label-cols="12" class="mb-0">
      <b-row>
        <b-col cols="4">
          <b-form-group label="Nome" label-for="nome">
            <b-form-input disabled id="nome" v-model="user.nome" name="nome" />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group label="Celular" label-for="telefone">
            <b-form-input
              disabled
              id="telefone"
              v-model="user.telefone"
              v-mask="['(##) #####-####']"
              name="telefone"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group label="Email" label-for="apto_para_operar">
            <b-form-input disabled id="email" v-model="user.email" name="email" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form-group>
  </b-form>
  </div>
</template>

<script>
import { BRow, BCol, BForm, BButton, BFormGroup, BFormInput, BFormCheckbox } from 'bootstrap-vue'
import { mask } from 'vue-the-mask'
import VueScrollbar from 'vue2-scrollbar'
import 'vue2-scrollbar/dist/style/vue2-scrollbar.css'

export default {
  name: 'InviteForm',
  components: {
    BRow,
    BCol,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    VueScrollbar,
  },
  props: {
    user: {
      type: Object,
      default: () => ({
        nome: '',
        email: '',
        telefone: '',
      }),
    },
  },
  directives: { mask },
  data() {
    return {
      codigo_if: '',
      scrollbar: {
        maxHeight: '250px',
        width: '100%',
      },
    }
  },
  methods: {
    async save() {
      this.$swal.fire({
        title: 'Processando',
        text: 'Aguarde enquanto os dados são atualizados!',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        onOpen: () => {
          this.$swal.showLoading()
        },
      })

      try {
        const invite = {
          ...this.invite
        }
        await this.$store.dispatch('admin/updateUser', this.user)
        this.$swal
          .fire({
            title: 'Sucesso',
            text: 'Usuario atualizado com sucesso',
            icon: 'success',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
          })
          .then((result) => {
            this.$emit('closeForm')
          })
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

<style lang="scss">
.border-gray {
  border: 1px solid #dae1e8;
}

.bg-gray {
  background-color: #eff4f6;
}

.table-container {
  width: 100%;
  border-collapse: collapse;
}

.table-container td {
  border: 1px solid #dae1e8;
  border-top: none;
  padding: 8px 12px;
  text-align: left;
}

.table-container td.cnpj {
  width: 15%;
  white-space: nowrap;
}

.table-container td.button {
  width: 12%;
  white-space: nowrap;
}
</style>
